import { useId } from 'react'

import type { JSX, SelectHTMLAttributes } from 'react'

type SelectProps = {
  label: string
  options: { label: string; value: string }[]
  value: string
  onChange: (value: string) => void
} & Omit<SelectHTMLAttributes<HTMLSelectElement>, 'value' | 'onChange'>

/** A native, controlled `<select>` with a visible label. `...rest` lands on the `<select>`. */
export default function Select({ label, options, value, onChange, ...rest }: SelectProps): JSX.Element {
  const id = useId()

  return (
    <div className="flex flex-col gap-1 font-sans">
      <label htmlFor={id} className="text-xs font-medium text-ink">
        {label}
      </label>
      <select
        {...rest}
        id={id}
        value={value}
        onChange={(event) => onChange(event.target.value)}
        className="min-h-11 min-[900px]:min-h-9 rounded-lg border border-border bg-surface px-3 text-[16px] min-[900px]:text-base text-ink focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-accent"
      >
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </div>
  )
}
